// Analytics Module - Central Exports
// Provides unified interface for all analytics functionality
// Extracted from metaTracking.js using facade pattern for better architecture

// Facebook Pixel Tracking (FBC/FBP management)
export {
  getEnhancedFbc,
  getEnhancedFbp,
  getFacebookTrackingParams,
  clearFacebookTrackingSession,
} from './fbpTracking';

// Analytics Utilities (shared helpers)
export {
  validateConfiguration,
  hashEmail,
  cleanPayload,
  fetchWithRetry,
  generateEventId,
  shouldSkipTracking,
  getMetaPixelId,
  isBrowserEnvironment,
  getTrackEventFunction,
  getMetaPixel,
  storeUserDataForTracking,
} from './analyticsUtils';

// Meta Event Handlers (main tracking functions)
export {
  trackLead,
  trackPurchase,
  trackPageView,
  trackInitiateCheckout,
  trackMetaEvent,
} from './metaEventHandlers';

// Module initialization for configuration validation (production only)
if (typeof window !== 'undefined') {
  // Wait for DOM and pixel to load, then validate (only in production environments)
  setTimeout(() => {
    import('./analyticsUtils').then(
      ({ shouldSkipTracking, validateConfiguration }) => {
        const skipCheck = shouldSkipTracking();
        if (!skipCheck.skip) {
          validateConfiguration();
        }
      }
    );
  }, 1000);
}
